import { render, staticRenderFns } from "./WaitlistOtherProducts.vue?vue&type=template&id=70d0040c"
import script from "./WaitlistOtherProducts.vue?vue&type=script&lang=js"
export * from "./WaitlistOtherProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports